// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ba667714","455":"bb1d9be2"}[chunkId] + ".chunk.js";
};